
  <div class="d-flex flex-column" *ngIf="entityType === EntityType.CAMPAIGN && eventType === EventType.BUDGET_CHANGES">
    <span class="text-large mb-1"><strong>Budget:</strong></span>
    <div class="d-flex gap-2 align-items-center">
        <div class="diff-box">
          <span class="val-old">{{changes?.budget?.old | currency : displayCurrency.code : displayCurrency.symbol : "1.2"}}</span>
          <span class="arrow">➜</span>
          <span class="val-new" [ngClass]="changes?.budget?.old > changes?.budget?.new ? 'decreased' : 'increased'">
            {{changes?.budget?.new | currency : displayCurrency.code : displayCurrency.symbol : "1.2"}}
          </span>
        </div>
    </div>
  </div>

  <div class="d-grid align-items-center" style="grid-template-columns: 140px 1fr; gap: 0.5rem;" *ngIf="entityType === EntityType.ITEM && eventType === EventType.PRICING_CHANGES_BY_RECOMMENDATION">
    <ng-container *ngFor="let changeField of ITEM_PRICE_RECOMMENDATION_CHANGE_FIELDS">
      <ng-container *ngIf="changes[changeField.field]">
        <span class="d-flex gap-2 text-large align-items-center">
          <span *ngIf="changeField.icon" class="label-icon" style="height: auto" [innerHTML]="sanitizer.bypassSecurityTrustHtml(changeField.icon)"></span>
          
          <strong>{{changeField.displayName}}:</strong></span>
        <div class="d-flex gap-2 align-items-center">
            <div class="diff-box">
              <span class="val-old">{{changes[changeField.field]?.old | currency : displayCurrency.code : displayCurrency.symbol : "1.2"}}</span>
              <span class="arrow">➜</span>
              <span class="val-new" [ngClass]="changes[changeField.field]?.old > changes[changeField.field]?.new ? 'decreased' : 'increased'">
                {{changes[changeField.field]?.new | currency : displayCurrency.code : displayCurrency.symbol : "1.2"}}
              </span>
            </div>
        </div>
      </ng-container>
    </ng-container>
  </div>